import { useTranslation } from 'react-i18next';
import { ElementsButton, Tooltip } from '../../../components';
import { usePresentationViewOptionsContext } from '../context';
import { otherShortcutMap } from '../util';
import { ShortcutLegendIcon } from '../../../components/ShortcutLegendIcon';

export function PresentationViewOptionsQuickActions() {
  const { t: tPages } = useTranslation('pages');
  const {
    allFocused,
    riskFocused,
    assetsFocused,
    cashFlowFocused,
    toggleAllElementsVisibility,
    toggleRiskElementsVisibility,
    toggleAssetsElementsVisibility,
    toggleCashFlowElementsVisibility,
  } = usePresentationViewOptionsContext();

  return (
    <>
      <p className="mb-2 px-4 text-darkMode-gray-light/70 font-medium text-[13px] leading-6">
        {tPages('full-screen-scorecard-view-options-quick-options')}
      </p>
      <div className="grid gap-[5px] items-center place-content-center grid-flow-col mb-4">
        <Tooltip
          placement="top"
          offset={[0, 10]}
          floatingElement={
            <div className="!h-[31px] p-2 shadow-classic text-center text-white text-xs bg-darkMode-gray-dropdown rounded">
              {tPages('full-screen-scorecard-view-options-quick-options-risk-tooltip')}
              <ShortcutLegendIcon className="-mt-1" shortcutCharacter={otherShortcutMap['toggleRiskElements']} />
            </div>
          }
        >
          <ElementsButton
            shape="filter"
            theme={riskFocused ? 'filter:active' : 'filter:inactive'}
            onClick={() => {
              toggleRiskElementsVisibility();
            }}
            label={tPages('full-screen-scorecard-view-options-quick-options-risk')}
          />
        </Tooltip>
        <Tooltip
          placement="top"
          offset={[0, 10]}
          floatingElement={
            <div className="!h-[31px] p-2 shadow-classic  text-center text-white text-xs bg-darkMode-gray-dropdown rounded">
              {tPages('full-screen-scorecard-view-options-quick-options-cash-flow-tooltip')}
              <ShortcutLegendIcon className="-mt-1" shortcutCharacter={otherShortcutMap['toggleCashFlowElements']} />
            </div>
          }
        >
          <ElementsButton
            shape="filter"
            theme={cashFlowFocused ? 'filter:active' : 'filter:inactive'}
            onClick={() => {
              toggleCashFlowElementsVisibility();
            }}
            label={tPages('full-screen-scorecard-view-options-quick-options-cash-flow')}
          />
        </Tooltip>
        <Tooltip
          placement="top"
          offset={[0, 10]}
          floatingElement={
            <div className="!h-[31px] p-2 shadow-classic text-center text-white text-xs bg-darkMode-gray-dropdown rounded">
              {tPages('full-screen-scorecard-view-options-quick-options-assets-tooltip')}
              <ShortcutLegendIcon className="-mt-1" shortcutCharacter={otherShortcutMap['toggleAssetsElements']} />
            </div>
          }
        >
          <ElementsButton
            shape="filter"
            theme={assetsFocused ? 'filter:active' : 'filter:inactive'}
            onClick={() => {
              toggleAssetsElementsVisibility();
            }}
            label={tPages('full-screen-scorecard-view-options-quick-options-assets')}
          />
        </Tooltip>
        <Tooltip
          placement="top"
          offset={[0, 10]}
          floatingElement={
            <div className="!h-[31px] p-2  shadow-classic text-center text-white text-xs bg-darkMode-gray-dropdown rounded">
              {tPages('full-screen-scorecard-view-options-quick-options-all-tooltip')}
              <ShortcutLegendIcon className="-mt-1" shortcutCharacter={otherShortcutMap['toggleAllElements']} />
            </div>
          }
        >
          <ElementsButton
            shape="filter"
            onClick={() => {
              toggleAllElementsVisibility();
            }}
            theme={allFocused ? 'filter:active' : 'filter:inactive'}
            label={tPages('full-screen-scorecard-view-options-quick-options-all')}
          />
        </Tooltip>
      </div>
    </>
  );
}
